'use strict';

var React = require('react'),
    _ = require('underscore'),
    Link = require('../atoms/Link'),
    ServiceTypes = require('../constants/ServiceTypes'),
    PureRenderMixin = require('../mixins/PureRenderMixin');

require('./ContactImporter.less');

var ContactImporter = React.createClass({
  mixins: [PureRenderMixin],

  propTypes: {
    services: React.PropTypes.array.isRequired,
    connectedServices: React.PropTypes.array.isRequired,
    onConnectClick: React.PropTypes.func.isRequired
  },

  render: function () {
    var services = _.map(this.props.services, this.renderService);

    return (
      <div className='ContactImporter'>
        <ul className='MetaList MetaList--inline MetaList--separated'>
          {services}
        </ul>
      </div>
    );
  },

  getServiceName: function (serviceType) {
    switch (serviceType) {
    case ServiceTypes.GOOGLE:
      return 'Gmail';
    case ServiceTypes.FACEBOOK:
      return 'Facebook';
    }
  },

  renderService: function (serviceType) {
    var isConnected = this.props.connectedServices.indexOf(serviceType) !== -1,
        classes = ['ContactImporter-' + serviceType.toLowerCase(), 'MetaList-item'],
        name = this.getServiceName(serviceType);

    if (isConnected) {
      classes.push('ContactImporter-' + serviceType.toLowerCase() + '--connected');
    }

    return (
      <li className={classes.join(' ')} key={serviceType}>
      {isConnected &&
        <span>
          <b>{name}</b>
          {' '}
          (Connected)
        </span>
      }

      {!isConnected &&
        <span>
          <b>{name}</b>
          {' '}
          (<Link onClick={this.handleConnectClick.bind(this, serviceType)}
                 color='green'
                 bold>
            Connect
          </Link>)
        </span>
      }
      </li>
    );
  },

  handleConnectClick: function (serviceType) {
    this.props.onConnectClick(serviceType);
  }
});

module.exports = ContactImporter;



/** WEBPACK FOOTER **
 ** ./molecules/ContactImporter.jsx
 **/